import { ConversionInfo } from './../../models/Coin';
import { StreamPrice } from './../../models/Socket';
import { CccSocketProvider } from './../../providers/ccc-socket/ccc-socket';
import { CoinsProvider } from './../../providers/coins/coins';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Coin, PriceFullRaw } from '../../models/Coin';
import { NavController } from 'ionic-angular';
import { StreamSubscription } from '../../models/Socket';

/**
 * Generated class for the CoinListItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'coin-list-item',
  templateUrl: 'coin-list-item.html'
})
export class CoinListItemComponent {

  @Input('coin') coin: Coin;
  @Input('conversion') conversion: ConversionInfo;
  @Output('sortData') sortData: EventEmitter<any> = new EventEmitter<any>();

  sub: StreamSubscription;
  imgUrl: string;
  hasData: boolean = false;

  constructor(public navCtrl: NavController, public socket: CccSocketProvider, public CP: CoinsProvider) {

  }

  ngOnInit() {
    this.imgUrl = `https://www.cryptocompare.com/${this.coin.ImageUrl}`;
    if(this.conversion.Conversion == 'direct'){
      this.sub = this.socket.getSubFromConversion(this.conversion);
    }else{
      this.sub = null;
    }
  }

  getPriceFromStream(): StreamPrice{
    let price = this.socket.getPrice(this.sub);
    if(price && price.PRICE){
      if(!this.hasData){
        this.sortData.emit({
          price: price.PRICE,
          cap: price.PRICE * this.conversion.Supply,
          vol: this.conversion.TotalVolume24H,
          change: price.CHANGE24HOURPCT
        });
        this.hasData = true;
      }
      return price;
    }else{
      return null;
    }
  }

  getPriceFromMap(): PriceFullRaw{
    let price = this.CP.getPrice(this.coin);
    if(price && price.PRICE){
      if(!this.hasData){
        this.sortData.emit({
          price: price.PRICE,
          cap: price.MKTCAP,
          vol: this.conversion.TotalVolume24H,
          change: price.CHANGEPCT24HOUR
        });
        this.hasData = true;
      }
      return price;
    }else{
      return null;
    }
  }



}



// WEBPACK FOOTER //
// ./src/components/coin-list-item/coin-list-item.ts